import { render } from "./PostDeliveryOrderCard.vue?vue&type=template&id=3962a6f1"
import script from "./PostDeliveryOrderCard.vue?vue&type=script&lang=js"
export * from "./PostDeliveryOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__